module.exports = __webpack_public_path__ + "static/advertising-hero-c6805155a34b9c5b603fa6155dd6a83a.jpg";